import styled from "styled-components";
import { sizes } from "../../components/01_config/Sizes";
import { MainHeader, MainWrapper } from "../../components/01_config/MainStyles";


const AboutWrapper = styled(MainWrapper)`
    gap: 0;
`

const AboutHeader = styled(MainHeader)`

`


export { AboutWrapper, AboutHeader }